export default "__VITE_ASSET__CTHKhmcR__"